module.exports = __webpack_public_path__ + "9788f41e/img/delete-icon.eb7de062.svg";